module.exports = __webpack_public_path__ + "sunsemweb/img/h1.8071de62.png";